<template>
  <div>
    <v-row class="mt-3 pa-1">
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.riskNo"
          address="C2"
          label="Risk No"
          outlined
          hide-details
          dense
        />
      </v-col>
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.initialReport"
          label="Initial Reporting"
          address="C6"
          outlined
          hide-details
          dense
        />
      </v-col>
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.lastUpdate"
          label="Last Update"
          address="K2"
          outlined
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-row class="pa-1">
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.company"
          label="Company"
          address="F2"
          outlined
          hide-details
          dense
        />
      </v-col>
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.currency"
          label="Currency"
          address="C4"
          outlined
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mb-3" dense>
      <v-col>
        <v-checkbox
          v-model="profileModelLocal.adHoc"
          label="Ad Hoc Report"
          hide-details
        />
      </v-col>
    </v-row>
    <v-divider class="mt-3" />
    <v-subheader>Responsible</v-subheader>
    <v-row class="mb-3 pa-1">
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.riskResponsible"
          address="F4"
          label="Risk Responsible"
          outlined
          hide-details
          dense
        />
      </v-col>
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.riskOwner"
          address="F6"
          label="Risk Owner"
          outlined
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-divider class="mt-3" />
    <v-subheader>Categories</v-subheader>
    <v-row class="mb-3 pa-1">
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.categoryMain"
          address="K4"
          label="Main Category"
          outlined
          hide-details
          dense
        />
      </v-col>
      <v-col>
        <InputsExcelTextField
          v-model="profileModelLocal.categorySub"
          address="K7"
          label="Sub Category"
          outlined
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-divider class="mt-3" />
    <v-subheader>Risks</v-subheader>
    <v-row class="pa-1">
      <v-col>
        <InputsExcelTextArea
          v-model="profileModelLocal.riskLabel"
          label="Risk Label"
          address="B12"
          outlined
          hide-details
          dense
          auto-grow
        />
      </v-col>
    </v-row>
    <v-row class="pa-1">
      <v-col>
        <InputsExcelTextArea
          v-model="profileModelLocal.riskDescription"
          label="Risk Description"
          address="B16"
          outlined
          hide-details
          dense
          auto-grow
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
const Excel = window.Excel
import InputsExcelTextField from '@/components/inputs/excel/InputsExcelTextField'
import InputsExcelTextArea from '@/components/inputs/excel/InputsExcelTextArea'
export default {
  components: {
    InputsExcelTextField,
    InputsExcelTextArea,
  },
  props: {
    profileModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    profileModelLocal: {
      get() {
        return this.profileModel
      },
      set() {
        this.$emit('input')
      },
    },
  },
  methods: {
    getLetter(col) {
      switch (col) {
        case 0:
          return 'A'
        case 1:
          return 'B'
        case 2:
          return 'C'
        case 3:
          return 'D'
        case 4:
          return 'E'
        case 5:
          return 'F'
        case 6:
          return 'G'
        case 7:
          return 'H'
        case 8:
          return 'I'
        case 9:
          return 'J'
        case 10:
          return 'K'
        case 11:
          return 'L'
        case 12:
          return 'M'
        case 13:
          return 'N'
        case 14:
          return 'O'
        case 15:
          return 'P'
        case 16:
          return 'Q'
        case 17:
          return 'R'
        default:
          return ''
      }
    },
    async getAddress(text, rowOffset, colOffset) {
      const position = await this.findRowPosition(text)

      const row = position.row + rowOffset
      const col = position.col + colOffset

      const rowVisual = row + 1
      this.addressLocal = this.getLetter(col) + String(rowVisual)
    },
    findRowPosition(text) {
      return Excel.run(async function (context) {
        const sheet = context.workbook.worksheets.getActiveWorksheet()

        const foundRange = sheet.findAllOrNullObject(text, {
          completeMatch: true,
          matchCase: false,
        })
        foundRange.load('areas')
        await context.sync()

        if (!foundRange.isNullObject) {
          const range = sheet.getRange(foundRange.areas.items[0].address)
          range.load('rowIndex, columnIndex')
          await context.sync()
          return {
            row: range.rowIndex,
            col: range.columnIndex,
          }
        } else {
          return null
        }
      })
    },
  },
}
</script>
